import { React, useState } from 'react';
import { Paper, Typography, Select, MenuItem, TextField, Button, Box, FormControl, InputLabel } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

const KoriSearchForm = ({ onSearch }) => {
  const [searchType, setSearchType] = useState('date');
  const [searchDate, setSearchDate] = useState(dayjs());
  const [searchWord, setSearchWord] = useState('');
  const [searchId, setSearchId] = useState('');

  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchType === 'date') {
      onSearch('date', { beforeDate: searchDate.toISOString() });
    }
    else if (searchType === 'keyword') {
      onSearch('keyword', { keyword: searchWord });
    }
    else if (searchType === 'id') {
      onSearch('id', { id: searchId });
    }
  };

  return (
    <Paper elevation={2} sx={{ marginBottom: '1em' }}>
      <Typography variant="h6" sx={{ padding: '1em' }}>
        {t('koriSearchForm.title')}
      </Typography>
      <form onSubmit={handleSubmit}>
        <FormControl sx={{ marginBottom: '1em', marginLeft: '1em', marginRight: '1em' }}>
          <InputLabel
            id="search-type-label"
            sx={{
              'color': '#0009',
              '&.Mui-focused': {
                color: '#0009',
              },
              '&.MuiInputLabel-shrink': {
                color: '#0009',
              },
            }}
          >
            {t('koriSearchForm.type')}
          </InputLabel>
          <Select
            value={searchType}
            label={t('koriSearchForm.type')}
            labelId="search-type-label"
            onChange={e => setSearchType(e.target.value)}
          >
            <MenuItem value="date">{t('koriSearchForm.date')}</MenuItem>
            <MenuItem value="keyword">{t('koriSearchForm.keyword')}</MenuItem>
            <MenuItem value="id">{t('koriSearchForm.id')}</MenuItem>
          </Select>
        </FormControl>
        {
          searchType === 'date' && (
            <DatePicker
              label={t('koriSearchForm.dateLabel')}
              value={searchDate}
              onChange={newValue => setSearchDate(newValue)}
              sx={{ marginBottom: '1em', marginLeft: '1em', marginRight: '1em' }}
            />
          )
        }
        {
          searchType === 'keyword' && (
            <TextField
              label={t('koriSearchForm.keywordLabel')}
              value={searchWord}
              sx={{ marginBottom: '1em', marginLeft: '1em', marginRight: '1em' }}
              onChange={(e => setSearchWord(e.target.value))}
              inputProps={{ minLength: 4 }}
              error={searchWord.length < 4 && searchWord.length > 0}
              helperText={searchWord.length < 4 && searchWord.length > 0 ? t('koriSearchForm.keywordError') : ''}
            />
          )
        }
        {
          searchType === 'id' && (
            <TextField
              label={t('koriSearchForm.id')}
              value={searchId}
              sx={{ marginBottom: '1em', marginLeft: '1em', marginRight: '1em' }}
              onChange={(e => setSearchId(e.target.value))}
              error={searchId.length > 0 && isNaN(searchId)}
              helperText={searchId.length > 0 && isNaN(searchId) ? t('koriSearchForm.idError') : ''}
            />
          )
        }
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ paddingBottom: '1em', marginLeft: '1em', marginRight: '1em' }}
        >
          <Button variant="contained" type="submit" fullWidth>{t('koriSearchForm.search')}</Button>
        </Box>
      </form>
    </Paper>
  );
};

export default KoriSearchForm;
